import styled from "@emotion/styled";
import { Button } from "@silvertours/front-shared";
var OptionsWrapper = /*#__PURE__*/ styled("div", {
    target: "e19ujdx70"
})("border-left:", function(param) {
    var isMobile = param.isMobile, theme = param.theme;
    return isMobile ? "0" : "1px solid ".concat(theme.color.natural50);
}, ";margin-left:", function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "0" : "1rem";
}, ";padding-left:", function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "0" : "1rem";
}, ";padding-right:", function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "0" : "1rem";
}, ";");
var OptionsSection = /*#__PURE__*/ styled("div", {
    target: "e19ujdx71"
})("&:not(&:first-of-type){margin-top:1.5rem;}");
var StyledLabel = /*#__PURE__*/ styled("label", {
    target: "e19ujdx72"
})("display:block;font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-size:1rem;padding-bottom:0.375rem;margin-bottom:0.625rem;");
var StyledButton = /*#__PURE__*/ styled(Button, {
    target: "e19ujdx73"
})("margin-top:1rem;");
var CheckboxContainer = /*#__PURE__*/ styled("div", {
    target: "e19ujdx74"
})("width:100%;display:inline-flex;cursor:pointer;user-select:none;flex-wrap:wrap;gap:0.75rem;> label{width:45%;align-items:center;}");
export { OptionsSection, OptionsWrapper, StyledLabel, StyledButton, CheckboxContainer };
